import React, { useState, useEffect } from 'react';
import Loading from '../components/Loading';
import axios from 'axios';
import ErrorPage from './error';
import { A } from 'hookrouter';
import DatePicker, { registerLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import ProfileImage from '../components/ProfileImage';
import moment from 'moment';
import CustomTimeInput from '../components/tables/shared/CustomTimeInput';
import CustomerInvoiceInfo from '../components/detail/CustomerInvoiceInfo';
import { addMonth } from '../components/tables/shared/FormatDetails';
import sv from 'date-fns/locale/sv';
import '../styles/pages/customer-details.scss';
import { useTranslation } from 'react-i18next';
import { CUSTOMER_DETAILS_BACK_BUTTON, CUSTOMER_DETAILS_ECO_EMP_NAME_LABEL, CUSTOMER_DETAILS_KAM_EMP_NAME_LABEL } from '../i18n/keyConstants';
registerLocale('sv', sv);

const CancelToken = axios.CancelToken;
let cancel;

const CustomerDetails = (props) => {
    const [customer, setCustomer] = useState();
    const [customerInvoiceInfo, setCustomerInvoiceInfo] = useState();
    const [id] = useState(props.customerId);
    const [loading, setIsLoading] = useState(true);
    const [error, setError] = useState();
    const [startDate, setStartDate] = useState(addMonth(new Date(), -1));
    const [endDate, setEndDate] = useState(addMonth(new Date(), -1));
    const { t } = useTranslation(['customerDetails']);


    useEffect(() => {
        function fetchCustomer() {
            const startDatePeriod = moment(startDate).format('YYYY-MM-DD');
            const endDatePeriod = moment(endDate).format('YYYY-MM-DD');
            const url = `api/customer/${id}/${startDatePeriod}/${endDatePeriod}`;

            cancel && cancel();

            try {
                axios
                    .get(url, {
                        cancelToken: new CancelToken((c) => {
                            cancel = c;
                        }),
                    })
                    .then((response) => {
                        const { customer, customerInvoiceInfo } = response.data;

                        setCustomer(customer);
                        setCustomerInvoiceInfo(customerInvoiceInfo);
                        setIsLoading(false);
                    })
                    .catch((thrown) => {
                        if (axios.isCancel(thrown)) {
                            console.warn('Request canceled', thrown.message);
                        } else {
                            const error = thrown.response;
                            setError(error);
                            setIsLoading(false);
                        }
                    });
            } catch (error) {
                console.error(error);
            }
        }
        fetchCustomer();
    }, [id, startDate, endDate]);

    const updateStartDate = (date) => {
        setStartDate(date);
        if (endDate < date) setEndDate(date);
    };

    const content = loading ? (
        <Loading />
    ) : error && error ? (
        <ErrorPage error={error} />
    ) : (
        <>
            <section className='details'>
                <div className='card-body bg-light-licorice'>
                    <div className='card-profile-img text-center margin-bottom-10px margin-top-10px'>
                        <img className='margin-none' src={ProfileImage} alt='' />
                    </div>
                    <h3 className='text-center c-white margin-bottom-none'>
                        <span className='padding-left-10px'> {customer.name}</span>
                        {customer.ecoEmpName ? (
                            <span
                                role='button'
                                className='customer-detail-info oi oi-info c-steelblue padding-left-10px'
                                data-toggle='modal'
                                data-target='#customer-detail-modal'></span>
                        ) : null}
                    </h3>
                    {customer.kam ? (
                        <p className='text-center c-light-grey'>
                                    {t(CUSTOMER_DETAILS_KAM_EMP_NAME_LABEL) }:{' '}
                            <A className='c-light-grey kam' href={`/employee/${customer.kamEmpID}/info`}>
                                {customer.kam}
                            </A>
                        </p>
                    ) : null}
                    <span className='details-back-btn'>
                            <button className='btn btn-outline-secondary d-flex c-white border-0' onClick={() => window.history.back()}>
                            <span className='oi oi-chevron-left'></span>
                                    <span className='d-none d-sm-block padding-left-10px'>{t(CUSTOMER_DETAILS_BACK_BUTTON)}</span>
                        </button>
                    </span>
                </div>
            </section>
            <section>
                <div className='container'>
                    <div className='row'>
                        <div className='col-12 col-md-8 offset-md-2'>
                            <div className='row'>
                                <div className='col-12 col-lg-10 offset-lg-1'>
                                    <div className='padding-top-30px d-flex justify-content-between align-items-center'>
                                        <span>
                                            <DatePicker
                                                selected={startDate}
                                                onChange={(date) => updateStartDate(date)}
                                                dateFormat='yyyy-MM'
                                                customInput={<CustomTimeInput />}
                                                showMonthYearPicker
                                                minDate={
                                                    customerInvoiceInfo && customerInvoiceInfo.firstInvoiceMonth
                                                        ? new Date(customerInvoiceInfo.firstInvoiceMonth)
                                                        : new Date()
                                                }
                                                maxDate={new Date()}
                                                locale='sv'
                                            />
                                        </span>
                                        <span className='oi oi-arrow-right padding-left-15px padding-right-15px'></span>
                                        <span>
                                            <DatePicker
                                                selected={endDate}
                                                onChange={(date) => setEndDate(date)}
                                                dateFormat='yyyy-MM'
                                                customInput={<CustomTimeInput />}
                                                showMonthYearPicker
                                                minDate={startDate}
                                                maxDate={new Date()}
                                                locale='sv'
                                                popperPlacement='bottom-end'
                                            />
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <CustomerInvoiceInfo customerInvoiceInfo={customerInvoiceInfo} customer={customer} loading={loading} error={error} />
                </div>
            </section>

            <div
                className='modal fade'
                id='customer-detail-modal'
                tabIndex='-1'
                role='dialog'
                aria-labelledby='customerDetail'
                aria-hidden='true'>
                <div className='modal-dialog' role='document'>
                    <div className='modal-content'>
                        <div className='modal-header bg-licorice d-flex align-items-center justify-content-between'>
                            <h3 className='c-white margin-none' id='exampleModalLabel'>
                                {customer.name}
                            </h3>
                            <button type='button' className='btn c-white' data-dismiss='modal' aria-label='Close'>
                                <span aria-hidden='true'>&times;</span>
                            </button>
                        </div>
                        {customer.kam && (
                            <div className='modal-body padding-bottom-none'>
                                        <p className='c-dim-gray margin-none modal-title'>{t(CUSTOMER_DETAILS_KAM_EMP_NAME_LABEL)}</p>
                                <p>{customer.kam}</p>
                            </div>
                        )}
                        {customer.ecoEmpName && (
                            <div className='modal-body padding-bottom-none'>
                                        <p className='c-dim-gray margin-none modal-title'>{t(CUSTOMER_DETAILS_ECO_EMP_NAME_LABEL)}</p>
                                <p>{customer.ecoEmpName}</p>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
    return content;
};

export default CustomerDetails;
